__turbopack_context__.v({
  "button": "CommonButton-module-scss-module__fMWGrq__button",
  "icon": "CommonButton-module-scss-module__fMWGrq__icon",
  "text": "CommonButton-module-scss-module__fMWGrq__text",
});
